import React from "react";
import MuiLink, { LinkProps } from "@material-ui/core/Link";
import { makeStyles, Theme } from "@material-ui/core/styles";
import classNames from "classnames";

const useStyles = makeStyles(({ link }: Theme) => ({
  root: {
    color: link,
    textDecoration: "none",
    cursor: "pointer"
  }
}));

type IProps = LinkProps & { component?: React.ReactNode; to?: any };

// @ts-ignore Long error, ignore for now
export const Link: React.FunctionComponent<IProps> = React.forwardRef(
  (
    { component, href = "#", target = "_blank", className, ...props }: IProps,
    ref
  ) => {
    const customClasses = useStyles();

    if (component) {
      return (
        <MuiLink
          component={component as any}
          className={classNames(customClasses.root, className)}
          ref={ref}
          {...props}
        />
      );
    }

    return (
      <MuiLink
        rel="noopener noreferrer"
        ref={ref}
        href={href}
        target={target}
        className={classNames(customClasses.root, className)}
        {...props}
      />
    );
  }
);
